export const dealWizardSteps = {
  CREATION_TYPE: 1,
  CONTRACT_TYPE: 2,
  CLIENT: 3,
  PROJECT_INFO: 4,
  CANDIDATE: 5,
  CONTRACT_DETAILS: 6,
  SUMMARY: 7
}

export var dealWizardStepsStatus = {
  1: false,
  2: false,
  3: false,
  4: false,
  5: false,
  6: false,
  7: false
}
